import React from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ConversationListHeaderProps {
  onNewConversation?: () => void;
}

export function ConversationListHeader({ onNewConversation }: ConversationListHeaderProps) {
  return (
    <div className="p-4 border-b border-border">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold">Conversations</h2>
        {onNewConversation && (
          <Button
            size="icon"
            variant="ghost"
            onClick={onNewConversation}
            className="h-8 w-8"
            aria-label="New conversation"
          >
            <Plus className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}